module.exports = __webpack_public_path__ + "static/media/basis-grotesque-mono-regular.59321204.ttf";